import React from "react";
import { Route } from "react-router-dom";
import LifeAtCampus from "../pages/LifeAtCampus";
import CampusLife from "../page_content/LifeAtManetSection/campus_life/CampusLife";
import CampusConduct from "../page_content/LifeAtManetSection/campus_conduct/CampusConduct";
import Accommodation from "../page_content/LifeAtManetSection/accommodation/Accommodation";
import MaritimeDay from "../page_content/LifeAtManetSection/maritime_day/MaritimeDay";
import VishwanathSport from "../page_content/LifeAtManetSection/vishwanath_sport/VishwanathSport";
import PersonaFest from "../page_content/LifeAtManetSection/persona_fest/PersonaFest";
import Library from "../page_content/LifeAtManetSection/library/Library";
import Sports from "../page_content/LifeAtManetSection/sports/Sports";
import StudentGrievance from "../page_content/LifeAtManetSection/student_grievance/StudentGrievance";
import ManetBlogs from "../page_content/LifeAtManetSection/manet_blogs/ManetBlogs";
import FullBlog from "../page_content/LifeAtManetSection/manet_blogs/FullBlog";
import Gallery from "../page_content/LifeAtManetSection/gallery/Gallery";
import Happenings from "../page_content/LifeAtManetSection/happenings/Happenings";
import HappeningsInner from "../page_content/LifeAtManetSection/happenings/HappeningsInner";

export const LifeAtCampusRoutes = (
  <Route path="lifeatcampus" element={<LifeAtCampus />}>
    <Route path="campus-life" element={<CampusLife />} />
    <Route path="conduct-at-campus" element={<CampusConduct />} />
    <Route path="accommodation" element={<Accommodation />} />
    <Route path="national-maritime-day" element={<MaritimeDay />} />
    <Route path="vishwanath-sport" element={<VishwanathSport />} />
    <Route path="mit-persona-fest" element={<PersonaFest />} />
    <Route path="library" element={<Library />} />
    <Route path="sports" element={<Sports />} />
    <Route path="student-grievance" element={<StudentGrievance />} />
    <Route path="happenings" element={<Happenings />} />
    <Route path="happenings/:id" element={<HappeningsInner />} />
    <Route path="gallery" element={<Gallery />} />
    <Route path="manet-blogs" element={<ManetBlogs />} /> {/* List page */}
    <Route path="manet-blogs/:id" element={<FullBlog />} />{" "}
    {/* Full blog page */}
  </Route>
);
